import React, { useEffect, useState } from 'react';
import confirmCircle from '../../Assets/icon/confirmCircle.png';
import apiClient from '../../Api/apiClient';
import { useNavigate, useLocation } from 'react-router-dom';
import PricingNotice from './PricingNotice';
import Contact from './../Contact/Contact';
import { CheckoutAlert } from '../../Modals/CheckoutAlert';

const PricingAfterLogIn = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { FromLimitedTender } = location.state || {};
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
  const [packagesData, setPackagesData] = useState([]);
  const [selectedPackageId, setSelectedPackageId] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleModalView = packageId => {
    setSelectedPackageId(packageId);
    setIsAlertModalOpen(true);
  };

  const handleModalClose = () => {
    setIsAlertModalOpen(false);
    setSelectedPackageId(null);
  };

  const fetchPackagesInfo = async () => {
    try {
      const response = await apiClient.get(`/user/visitor/package`);
      const activePackages = response.data.data.filter(pkg => pkg.status === 1);
      setPackagesData(activePackages || []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPackagesInfo();
  }, []);

  // Static features list
  const features = [
    'Daily Published Tenders',
    'Access to Private Tenders',
    'Detailed Tender Documents',
    'Add to Favorites',
    'Unlimited tender published request',
  ];
  return (
    <>
      <div className="md:px-0 px-4 2xl:mt-44 md:mt-36 mt-36">
        {!FromLimitedTender && <PricingNotice />}
      </div>
      <div className="px-6 py-10 container mx-auto">
        <h2 className="text-center text-2xl font-bold mb-2">
          Pick your perfect plan
        </h2>
        <p className="text-center text-xs text-gray-600 2xl:mb-8 mb-4">
          To view the full details of the tender, please choose a subscription
          to become one of our premium members
        </p>

        {loading ? (
          <p className="text-center md:h-60 text-sm font-semibold">
            Loading packages...
          </p>
        ) : packagesData.length === 0 ? (
          <p className="text-center md:h-60 mt-10 text-red-500 text-sm font-semibold">
            No Packages Found
          </p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {packagesData.map((plan, index) => (
              <div
                onClick={() => handleModalView(plan.id)}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                key={index}
                className="rounded-xl cursor-pointer shadow-md text-center hover:shadow-lg border border-gray-300 flex flex-col h-full"
              >
                {plan.duration === 6 ? (
                  <div className="text-white font-medium border bg-blue-700 rounded-xl p-4 border-DefaultColor">
                    <h1 className="md:text-xl text-lg font-bold">
                      {plan.name}
                    </h1>
                    <h3 className="text-xs">{plan.duration} Months</h3>
                  </div>
                ) : (
                  <div
                    className={`font-medium border rounded-xl p-4 ${
                      hoveredIndex === index
                        ? 'bg-DefaultColor text-white border-DefaultColor'
                        : ''
                    }`}
                  >
                    <h1 className="md:text-xl text-lg font-bold">
                      {plan.name}
                    </h1>
                    <h3
                      className={`text-xs text-gray-600 ${
                        hoveredIndex === index
                          ? 'bg-DefaultColor text-white border-DefaultColor'
                          : ''
                      }`}
                    >
                      {plan.duration} {plan.duration === 1 ? 'Month' : 'Months'}
                    </h3>
                  </div>
                )}

                {/* Content wrapper */}
                <div className="px-4 py-6 2xl:py-8 flex-grow">
                  <div className="flex items-center justify-center gap-4">
                    <p className="md:text-4xl text-3xl font-bold text-gray-700">
                      ৳ {plan.amount}
                    </p>
                    {plan.discount_percent !== 0 && (
                      <div className="font-bold text-gray-700">
                        <h1 className="text-xs">Regular Price</h1>৳{' '}
                        <del className="text-sm">{plan.regular_amount}</del>
                      </div>
                    )}
                  </div>
                  {plan.discount_percent !== 0 && (
                    <span className="text-red-500 text-xs font-medium">
                      Save {plan.discount_amount} tk. with{' '}
                      {plan.discount_percent}% discount
                    </span>
                  )}
                  <ul className="text-left text-xs mt-6 2xl:space-y-4 space-y-2">
                    {features.map((feature, i) => (
                      <li key={i} className="flex items-center gap-2">
                        <img src={confirmCircle} alt="" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Button */}
                <div className="p-4">
                  {plan.duration === 6 ? (
                    <button
                      // onClick={() => handleModalView(plan.id)}
                      className="w-full bg-blue-700 text-white py-2 rounded-lg "
                    >
                      {/* Get Started */}
                      Buy Package
                    </button>
                  ) : (
                    <button
                      // onClick={() => handleModalView(plan.id)}
                      className={`w-full border-DefaultColor border text-DefaultColor hover:text-white py-2 rounded-lg hover:bg-blue-700 ${
                        hoveredIndex === index
                          ? 'bg-blue-700 text-white border-DefaultColor'
                          : ''
                      }`}
                    >
                      Buy Package
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        <CheckoutAlert
          isOpen={isAlertModalOpen}
          onClose={handleModalClose}
          packageId={selectedPackageId}
        />
      </div>
      <Contact />
    </>
  );
};

export default PricingAfterLogIn;

